import { COOKIE_NAME_B2C_USER_TYPE } from './constants';

export function setB2cUserTypeCookie(userType: string, domain: string, maxAge = 3600): void {
  document.cookie = `${COOKIE_NAME_B2C_USER_TYPE}=${userType}; path=/; domain=${domain}; max-age=${maxAge}`;
}

export function getB2cUserTypeCookie(): string | null {
  if (typeof document === 'undefined') return null;
  return document.cookie.split('; ').find((row) => row.startsWith(`${COOKIE_NAME_B2C_USER_TYPE}=`))?.split('=')[1] ?? null;
}
